<template>
  <v-app>
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
    <v-snackbar v-model="showRefreshMessage" color="info" :timeout="0">
      {{ $t("A new version of this website is available") }}
      <v-btn color="info" v-on:click.stop="window.location.reload(true)">{{
        $t("REFRESH")
      }}</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  name: "App",
  data: () => ({
    refreshCheckInterval: null,
    refreshCheckContent: null,
    showRefreshMessage: false
  }),
  metaInfo: {
    title: "Media Hoarder",
    titleTemplate: "%s | Media Hoarder",
    htmlAttrs: { lang: "en" },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" }
    ]
  },

  computed: {
    window() {
      return window;
    }
  },

  methods: {
    async refreshCheck() {
      try {
        console.log("[refreshCheck] START");
        const res = await axios.get(
          "index.html",
          {
            headers: {
              accept: "application/json, text/plain, */*",
              "accept-language": "en-US,en;q=0.9",
              "cache-control": "no-cache",
              pragma: "no-cache",
              expires: "0",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Headers": "Content-Type, Authorization",
              "Content-Type": "application/json"
            }
          }
        );

        console.log("[refreshCheck] res.data:", res.data);

        if (!res.data) {
          return;
        }

        if (!this.refreshCheckContent) {
          console.log("[refreshCheck] storing content");
          this.refreshCheckContent = res.data;
          return;
        }

        if (this.refreshCheckContent !== res.data) {
          console.log(
            "[refreshCheck] content has changed, showing message to the user"
          );
          this.showRefreshMessage = true;
          return;
        }
        console.log("[refreshCheck] content is unchanged");
      } catch (err) {
        console.error(err);
      }
    }
  },

  /**
   * Lifecycle Hooks
   */
  created() {
    console.log("navigator.languages:", navigator.languages);
    console.log("this.$i18n:", this.$i18n);

    if (navigator.languages && navigator.languages.length > 0) {
      for (let i = 0; i < navigator.languages.length; i++) {
        const lang = navigator.languages[i].split("-")[0];

        if (Object.keys(this.$i18n.messages).find(locale => locale === lang)) {
          console.log("locale found:", lang);
          this.$i18n.locale = lang;
          break;
        }
      }
    }
  },

  async mounted() {
    console.log("[App mounted] setting refreshCheckInterval");
    this.refreshCheck();
    this.refreshCheckInterval = setInterval(async () => {
      this.refreshCheck();
    }, 1 * 60 * 1000);
  },

  beforeDestroy() {}
};
</script>

<style lang="sass">
.extra-padding
  padding-bottom: 96px !important
  padding-top: 96px !important

  @media screen and (max-width: 959px)
    padding-top: 48px !important
    padding-bottom: 48px !important

html
  scroll-behavior: smooth
</style>
